import * as React from "react";
import { IconProps } from "../types";

const LawShieldIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <rect
          x="8.919"
          y="8.6904"
          width="6.0858"
          height="3.5429"
          rx=".75"
          ry=".75"
          transform="translate(-3.8941 11.5225) rotate(-45)"
          fill={color}
          opacity="0.3"
        />
        <rect
          x="8.919"
          y="8.6904"
          width="6.0858"
          height="3.5429"
          rx=".75"
          ry=".75"
          transform="translate(-3.8941 11.5225) rotate(-45)"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="13.2145"
          y1="11.7145"
          x2="16.25"
          y2="14.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m15.25,5.2507v-.7708c0-.4341-.281-.8188-.695-.9519l-5.25-1.6802c-.199-.063-.412-.063-.61,0l-5.25,1.6802c-.414.1318-.695.5168-.695.9519v6.52c0,3.03,4.684,4.748,5.942,5.155.203.0659.413.0659.616,0,.0176-.0059.0425-.0144.0615-.0208"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default LawShieldIcon;
